import { PreRenderService } from './../services/pre-render.service';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';


@Injectable()
export class RedirectGuard implements CanActivate {
  constructor(
    private router: Router,
    private preRenderService: PreRenderService
    ) { }

  canActivate(
    route: ActivatedRouteSnapshot
  ): boolean {
    if (route.data && route.data.externalRedirect) {
      if (this.preRenderService.isBrowserMode) window.location.href = route.data.externalRedirect;
      this.preRenderService.setPreRenderFlag(301, route.data.externalRedirect);
    }

    return true;
  }
}
